var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2806_12585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35305 8.4785C1.06639 4.4185 4.41972 1.06517 8.47972 1.35183C12.0064 1.59183 14.6664 4.67183 14.6664 8.21183V8.9385C14.6664 9.8985 14.1197 10.8118 13.2264 11.1652C12.1397 11.5985 10.9531 11.1718 10.3597 10.3585C9.59305 11.1385 8.42639 11.5318 7.19972 11.2452C5.93972 10.9452 4.94639 9.89183 4.71972 8.6185C4.31305 6.3385 6.22639 4.3785 8.49305 4.70517C10.1464 4.9385 11.3331 6.44517 11.3331 8.1185V8.95183C11.3331 9.4785 11.8064 9.9985 12.3331 9.9985C12.8597 9.9985 13.3331 9.4785 13.3331 8.95183V8.2185C13.3331 5.73183 11.7197 3.45183 9.30639 2.8385C5.43972 1.8385 1.83972 5.44517 2.83305 9.31183C3.45305 11.7185 5.73305 13.3318 8.21972 13.3318H10.6664C11.0331 13.3318 11.3331 13.6318 11.3331 13.9985C11.3331 14.3652 11.0331 14.6652 10.6664 14.6652H8.20639C4.67305 14.6652 1.59305 12.0052 1.35305 8.4785ZM5.99972 7.9985C5.99972 9.10516 6.89306 9.9985 7.99972 9.9985C9.10639 9.9985 9.99972 9.10516 9.99972 7.9985C9.99972 6.89183 9.10639 5.9985 7.99972 5.9985C6.89306 5.9985 5.99972 6.89183 5.99972 7.9985Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2806_12585)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#A6B0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/At.4aad2dd9.svg";
export { ForwardRef as ReactComponent };